import React, { useState, useCallback } from 'react'
import { useMount } from 'react-use'
import classnames from 'classnames'
import styles from './renderItem.module.scss'
import OrderQuickPreview from './QuickPreview/Order'
import { Avatar, Tag, Tooltip } from 'antd'
import StatusBadge from '@/components/StatusBadge';
import dayjs from 'dayjs'
import * as utils from '@/utils'
// import * as utils from '@/utils'

function MessageItem(props) {
  const handleOnClick = () => {
    props.onClick({
      title: `聊天记录 关键字:《${props.keyword}》`,
      view: <OrderQuickPreview orderId={props.data.order_id || props.data.order} />
    })
  }

  const fromType = {
    staff: '企业员工',
    manager: '客服',
    system: '系统'
  }[props.data?.from_type] || '未知类型'
  return (
     <div className={classnames(styles.message, styles.item)} onClick={handleOnClick}>
      <div className={styles.wrap}>
        <div className={styles.header}>
          <span className={classnames('text', styles.title)}>来自{fromType}的消息:</span>
          <span className={classnames('text', styles.time)}>
            {dayjs(props.data.crreatedAt).format('YYYY-MM-DD HH:mm')}
          </span>
        </div>
        <div className={styles.content}>
          <div className={classnames('text', styles.more)}>点击查看相应工单</div>
          <div className={classnames('text', styles.matchedMessage)}>
            {props.data?.text || props.data?.message_type || '没有文本消息'}
          </div>
        </div>
      </div>
    </div>
  )
}

function OrderItem(props) {
  const handleOnClick = () => {
    console.log('>>>>>>> props.data:', props.data)
    props.onClick({
      title: `工单 关键字:《${props.keyword}》`,
      view: <OrderQuickPreview orderId={props.data._id} />
    })
  }
  const status = utils.getStatus(props.data)

  return (
    <div className={classnames(styles.order, styles.item)} onClick={handleOnClick}>
      <div className={styles.wrap}>
        <div className={styles.left}>
          <div className={classnames('iconfont', styles.orderIcon)}>&#xe62f;</div>
        </div>
        <div className={styles.right}>
          <div className={styles.header}>
            <span className={classnames('text', styles.title)}>工单号: {props.data.order_no}</span>
            <StatusBadge
              style={{ backgroundColor: '#F33535', color: '#FFFFFF'}}
              style={status.style}
              className={styles.orderStatus}>{status.text}</StatusBadge>
            <div className={styles.orderType}>
              <Tag>{props.data.order_type === 1 ? '安装': '维修'}</Tag>
              <Tag>{props.data.payer_type === 1 ? '保内': '保外'}</Tag>
            </div>
            {
              props.data.prev_order && (
                <div className={styles.hasPrevOrder}>
                  <Tag className={styles.convTag} color="orange">再次上门</Tag>
                </div>
              )
            }
            <span className={classnames('text', styles.time)}>
              {dayjs(props.data.crreatedAt).format('YYYY-MM-DD HH:mm')}
            </span>
          </div>
          <div className={styles.content}>
            <div className={classnames('text', styles.more)}>点击查看工单</div>
            <div className={classnames('text', styles.desc)}>
              {props.data.desc}
            </div>
            <div className={classnames('text', styles.concatInfo)}>
              {props.data.address} {props.data.contact_name} {props.data.contact_mobile}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default function(props) {
  if (props.type === 'orders') {
    return <OrderItem {...props} />
  } else if (props.type === 'messages') {
    return <MessageItem {...props} />
  } else {
    return (
      <div>不支持类型</div>
    )
  }
}

// 师傅信息不好获取，暂时先不弄
// return (
//   <div className={classnames(styles.worker, styles.item)} onClick={handleOnClick}>
//     <div className={styles.wrap}>
//       <div className={styles.left}>
//         <div className={classnames('iconfont', styles.workerIcon)}>&#xe64f;</div>
//       </div>
//       <div className={styles.right}>
//         <div className={styles.header}>
//           <span className={classnames('text', styles.title)}>工单号: 3333-2221-3114</span>
//           <StatusBadge
//             style={{ backgroundColor: '#F33535', color: '#FFFFFF'}}
//             // style={status.style}
//             className={styles.orderStatus}>正在进行中</StatusBadge>
//           <div className={styles.orderType}>
//             <Tag>安装</Tag>
//             <Tag>保内</Tag>
//           </div>
//           <div className={styles.hasPrevOrder}>
//             <Tag className={styles.convTag} color="orange">再次上门</Tag>
//           </div>
//           <span className={classnames('text', styles.time)}>2020-03-12 12:33:11</span>
//         </div>
//         <div className={styles.content}>
//           <div className={classnames('text', styles.more)}>点击查看工单</div>
//           <div className={classnames('text', styles.desc)}>
//             order.desc 查看工单详情 e
//           </div>
//           <div className={classnames('text', styles.concatInfo)}>order.address order.concat_name ordr.concat_mobil</div>
//         </div>
//       </div>
//     </div>
//   </div>
// )
// }
